import { Stack } from "@mui/material";
import { type ReactElement, type ReactNode, useState } from "react";
import { StableSwitcherItem } from "./Item";

export interface IStableSwitcherProps {
  active: string;
  children: ReactElement<{ "data-switcher": string }>[];
}

export const StableSwitcher = ({ active, children }: IStableSwitcherProps) => {
  const [size, setSize] = useState({ width: 0, height: 0 });

  const elements: ReactNode[] = [];
  for (const child of children) {
    elements.push(
      <StableSwitcherItem value={child.props["data-switcher"]} active={active} setSize={setSize}>
        {child}
      </StableSwitcherItem>
    );
  }

  return <Stack sx={{ position: "relative", width: size.width, height: size.height }}>{elements}</Stack>;
};
